import { Icon } from '@iconify/react';
import React, { useRef, useState } from 'react';
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import EditIcon from '@mui/icons-material/Edit';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { makeStyles } from '@mui/styles';
// material
import { Menu, MenuItem, IconButton, ListItemIcon, ListItemText } from '@mui/material';
import useFeatures from '../../customContextProviders/FeatureContext';

// ----------------------------------------------------------------------

const useStyles = makeStyles((theme) => ({
  menuItem: {
    fontSize: '14px',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px'
    },
    minHeight: '20px',
    borderRadius: '8px',
    marginInline: theme.spacing(1)
  }
}));

export default function RouteMoreMenu({ handleUser, handleClicks }) {
  const classes = useStyles();
  const ref = useRef(null);
  const feature = useFeatures();

  const [isOpen, setIsOpen] = useState(false);
  console.log('');

  return (
    <>
      <IconButton data-testid="route-more-menu" ref={ref} onClick={() => setIsOpen(true)}>
        <Icon icon={moreVerticalFill} width={20} height={20} />
      </IconButton>

      <Menu
        open={isOpen}
        anchorEl={ref.current}
        onClose={() => setIsOpen(false)}
        PaperProps={{
          sx: { width: 200, maxWidth: '100%' }
        }}
        sx={{
          '& .MuiListItemText-root > .MuiTypography-root': {
            color: '#000',
            fontWeight: 600,
            fontStyle: 'normal'
          },
          pl: 3
        }}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {/* <MenuItem onClick={() => { setIsOpen(false); handleClicks("view_route") }} sx={{ color: 'text.secondary' }}>
          <ListItemText primary="View Route" primaryTypographyProps={{ variant: 'body2' }} />
        </MenuItem> */}

        {feature?.route?.editRouteDetail && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('editroute');
            }}
            sx={{ color: 'text.secondary' }}
            className={classes.menuItem}
          >
            <ListItemIcon>
              <EditIcon />
            </ListItemIcon>
            <ListItemText primary="Edit Route" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}

        {feature?.route?.deleteRoute && (
          <MenuItem
            onClick={() => {
              setIsOpen(false);
              handleClicks('deleteroute');
            }}
            sx={{ color: 'text.secondary' }}
            className={classes.menuItem}
          >
            <ListItemIcon>
              <RemoveCircleOutlineOutlinedIcon sx={{ color: '#C30A0A' }} />
            </ListItemIcon>
            <ListItemText primary="Delete Route" primaryTypographyProps={{ variant: 'body2' }} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
